import type { Env } from "../../../common/types.ts";

// Default values, to be overwritten on initialization by global variables from ui
const env: Env = {
	bbgmVersion: "",
	mobile: false,
};

export default env;
